import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared.module';
import { CoreModule } from '../../core/core.module';
import { RightMenuComponent } from './right-menu/right-menu.component';
import { MenuComponent } from './menu/menu.component';
import { AppContainerComponent } from './app-container/app-container.component';
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { ProcessingItemComponent } from "./right-menu/processing-item/processing-item.component";


export const components = [
	MenuComponent,
	RightMenuComponent
];

@NgModule({
    imports: [
        RouterModule.forRoot([]),
        SharedModule,
        CoreModule,
        MatSlideToggleModule,
        ProcessingItemComponent
    ],
	declarations: [
		...components,
		AppContainerComponent,
	],
	providers: [
	],
	exports: [
		...components,
		SharedModule
	]
})
export class LayoutModule { }
